import { PlusOutlined } from "@ant-design/icons";
import { useAddCreatorsToBuckets } from "@entities/bucket/lib/hooks/useAddCreatorsToBuckets";
import CampaignReachoutInfluencerModal from "@entities/campaign-reach-out/ui/CampaignReachoutModal";
import { useCampaignStore } from "@entities/global-discovery/store/useCampaignStore";
import { ToastService } from "@shared/lib/services";
import { AddBy, IModifiedGlobalCreator } from "@shared/lib/types";
import { Button } from "@shared/ui";
import AddToBucket from "@shared/ui/Modals/AddToBucket";
import { Divider, Modal, Row, Space, Spin } from "antd";
import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";

interface SelectionFooterProps {
  selectedCreators: IModifiedGlobalCreator[];
  onDeselectAll: () => void;

  onAddToCampaign?: (creators: IModifiedGlobalCreator[]) => void;
  onHighlightCampaignSelector?: () => void;

  isAddingToCampaignLoading?: boolean;
}

export function SelectionFooter({
  selectedCreators,
  onDeselectAll,

  onAddToCampaign,
  onHighlightCampaignSelector,

  isAddingToCampaignLoading,
}: SelectionFooterProps) {
  const { campaign } = useCampaignStore();
  const selectedCount = selectedCreators.length;

  const { addToBucket, isAdding, isAdded, addToBucketError } =
    useAddCreatorsToBuckets();
  const [bucketIds, setselectedbuckedIds] = useState<string[]>([]);
  const [isBucketModalVisible, setBucketModalVissible] =
    useState<boolean>(false);
  const [isCampaignReachOutModalVisible, setCampaignReachOutModalVisible] =
    useState<boolean>(false);

  useEffect(() => {
    if (isAdded) {
      setBucketModalVissible(false);
      setselectedbuckedIds([]);
      onDeselectAll();
      ToastService.success("Influencers added to buckets");
    } else if (addToBucketError) {
      ToastService.error(addToBucketError?.message);
    }
  }, [isAdded, addToBucketError]);

  const handleAdd = (bucketIds: string[]) => {
    const addBy: AddBy[] = selectedCreators.map((creator) => {
      return {
        socialMediaHandle: {
          platform: creator?.work_platform?.name?.toLowerCase() || "",
          username: creator?.platform_username || "",
          link: creator?.url || "",
          fansCount: creator?.follower_count || creator?.subscriber_count || 0,
        },
      };
    });
    addToBucket({ bucketIds, addBy });
  };

  // const { userDetails } = useGetMe();
  // const isAddToCampaignDisabled =
  //   userDetails?.userEntity?.permissions.includes("super-brand-org") ||
  //   userDetails?.userEntity?.permissions.includes("super")
  //     ? false
  //     : !userDetails?.userEntity?.permissions.includes("modify-briefs-org");

  if (selectedCount === 0) {
    return null;
  }

  const handleAddToCampaign = () => {
    if (campaign?._id) {
      onAddToCampaign?.(selectedCreators);
    } else {
      onHighlightCampaignSelector?.();
    }
  };

  return (
    <>
      <div className={styles.footer}>
        <div className={styles.footerContent}>
          <Space size="middle" align="center">
            <span className={styles.selectedBadge}>{selectedCount} selected</span>
            <Button
              type="text"
              onClick={onDeselectAll}
              className={styles.deselectButton}
            >
              Deselect all
            </Button>
          </Space>
          <Space size="small" align="center">
            <Button
              onClick={() => {
                selectedCreators?.forEach((influencer) => {
                  if (influencer?.url) {
                    window.open(influencer?.url || "", "_blank");
                  }
                });
              }}
            >
              Open Profile Links
            </Button>
            <Button onClick={() => setCampaignReachOutModalVisible(true)}>
              Campaign Reach Out
            </Button>
            <Button onClick={() => setBucketModalVissible(true)}>
              Add To Bucket
            </Button>
            <Button
              type="primary"
              size="middle"
              // disabled={isAddToCampaignDisabled}
              icon={<Plus size={16} />}
              onClick={handleAddToCampaign}
              loading={isAddingToCampaignLoading}
              className={styles.addToCampaignButton}
            >
              Add to Campaign
            </Button>
          </Space>
        </div>
      </div>
      <Modal
        title="Add Influencer To Bucket"
        open={isBucketModalVisible}
        onCancel={() => setBucketModalVissible(false)}
        footer={
          <>
            <Divider style={{ margin: "8px 0" }} />
            <Space
              style={{
                padding: "0 8px 4px",
                width: "100%",
                justifyContent: "space-between",
              }}
            ></Space>
            {bucketIds.length > 0 && (
              <Row style={{ justifyContent: "center", padding: 10 }}>
                {isAdding ? (
                  <Spin style={{ width: 30, height: 30 }} />
                ) : (
                  <Button
                    onClick={async () => handleAdd(bucketIds)}
                    icon={<PlusOutlined />}
                  >
                    Add to selected buckets
                  </Button>
                )}
              </Row>
            )}
          </>
        }
        destroyOnClose
      >
        <AddToBucket
          bucketIds={bucketIds}
          setselectedbuckedIds={setselectedbuckedIds}
          mode="multiple"
        />
      </Modal>
      <CampaignReachoutInfluencerModal
        visible={isCampaignReachOutModalVisible}
        onClose={() => setCampaignReachOutModalVisible(false)}
        userData={selectedCreators?.map((ele) => ({
          name: ele.full_name,
          platform: ele.work_platform?.name?.toLowerCase() || "",
          username: ele.platform_username,
          profilePicUrl: ele.image_url,
          link: ele.url,
        }))}
      />
    </>
  );
}
